import { Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-coming-soon-screen',
  imports: [TranslocoPipe],
  templateUrl: './coming-soon-screen.component.html',
  styleUrls: ['./coming-soon-screen.component.scss'],
})
export class ComingSoon {
  // inputs
  useDarkMode = input<boolean>(true);
}
